<template>
  <v-card-text>
    <div class="d-flex align-center justify-space-between flex-wrap ga-4">
      <div class="d-flex align-center ga-2 mb-1 flex-wrap">
        <div class="d-flex align-start ga-3">
          <v-avatar
            class="bg-blue-lighten-5 text-blue-darken-3"
            rounded="lg"
            size="40">
            <v-icon icon="mdi-alert-outline" size="20"></v-icon>
          </v-avatar>
          <div class="d-flex flex-column">
            <div class="d-flex align-center ga-1">
              <span class="font-size-13 font-weight-bold text-medium-emphasis">
                {{ incidentSource.number }}
              </span>
              <v-chip
                :style="getIncidentStatusChipStyle(incidentSource.status?.id)"
                border
                class="font-weight-bold"
                density="comfortable"
                rounded="lg"
                size="small"
                variant="flat">
                {{ incidentSource.status?.name }}
              </v-chip>
            </div>
            <span class="font-size-16 font-weight-bold">
              {{ incidentSource.name }}
            </span>
            <div class="font-size-12 text-disabled">
              <span v-if="incidentSource.occurredDate">
                Створено:
                {{
                  new CustomDate(incidentSource.created_at).toString({
                    time: true,
                    format: 'locale-hybrid',
                  })
                }}
              </span>
              <span
                v-if="incidentSource.created_at && incidentSource.initiator">
                ·
              </span>
              <span v-if="incidentSource.initiator">
                {{
                  getPersonName(incidentSource.initiator, { initials: true })
                }}
              </span>
              <span
                v-if="incidentSource.initiator && incidentSource.resolution">
                ·
              </span>
              <span
                v-if="incidentSource.resolution"
                class="font-weight-bold text-green-darken-3">
                Врегульовано:
                {{
                  new CustomDate(incidentSource.resolution.created_at).toString(
                    {
                      time: true,
                      format: 'locale-hybrid',
                    }
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="statusActions.length"
        class="d-flex align-center ga-2 flex-wrap">
        <v-btn
          v-for="action in statusActions"
          :key="action.statusId"
          :color="action.color"
          :loading="$loading.isLoading('incidentSetStatus')"
          @click="openStatusDialog(action)">
          <div class="d-flex align-center ga-1 font-weight-light">
            <v-icon color="white">mdi-swap-horizontal</v-icon>
            {{ action.label }}
          </div>
        </v-btn>
      </div>
    </div>
  </v-card-text>
</template>

<script lang="ts" setup>
import { useIncident } from '../Incident'
import { getIncidentStatusChipStyle } from '../../constants'
import { CustomDate } from 'best-modules/utils'
import { getPersonName } from 'best-modules/utils/helpers'

defineOptions({
  name: 'IncidentHeader',
})

const { incidentSource, openStatusDialog, statusActions } = useIncident()
</script>
